import { CheckoutConfig } from '@share/interfaces';
import { Frames } from 'frames-react';
import { ListingType, PaymentGatewayName, PaymentStatus } from '@share/enums';
import { toast } from 'react-toastify';
import { useAPI, useSystemConfig } from 'src/hooks';
import { useDebouncedCallback } from 'use-debounce';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { web3 } from '@state/web3';
import CheckoutPaymentFrame from '@com/payment/CheckoutPaymentFrame';

interface Params {
  tokenId: number;
  collectionAddress: string;
  contractChainId: number;
  bidPrice?: number; // only for bid
  totalPrice: number;
  checked: boolean;
  type: ListingType;
}

function CheckoutBidBuyFrame({
  checked,
  collectionAddress,
  contractChainId,
  tokenId,
  totalPrice,
  type,
  bidPrice,
}: Params): JSX.Element {
  /* Define state / hook */
  const [isPaying, setIsPaying] = useState(false);
  const [paymentResult, setPaymentResult] = useState<any>();
  const [error, setError] = useState<string>();
  const { getAddress } = web3.useContainer();
  const { t } = useTranslation();
  const { processCheckoutBid, processCheckoutBuy } = useAPI();
  const { config } = useSystemConfig();
  /* Custom Data Object for render or other usages */

  /* render control function / logic */
  const handleSubmit = useDebouncedCallback(
    async () => {
      const paymentError = (msg?: string) => {
        toast.error(msg || t('payment.failed'));
        setIsPaying(false);
      };
      if (!checked) {
        toast.info(t('toastMessage.checkTerms'));
        return;
      }
      setError(undefined);
      setIsPaying(true);
      let result = paymentResult;
      if (!result)
        try {
          result = await Frames.submitCard();
          setPaymentResult(result);
        } catch (err: any) {
          setError(err);
          setIsPaying(false);
        }
      let response;
      if (result?.token) {
        try {
          if (type === 'buy') {
            response = await processCheckoutBuy({
              chainId: contractChainId,
              collectionAddress,
              tokenId,
              buyerAddress: getAddress(),
              totalPrice,
              cardToken: result?.token,
            });
          }
          if (type === 'bid') {
            response = await processCheckoutBid({
              chainId: contractChainId,
              collectionAddress,
              tokenId,
              bidPrice: Number(bidPrice),
              totalPrice,
              bidderAddress: getAddress(),
              cardToken: result?.token,
            });
          }
          if (response?.type === PaymentStatus.NEED_AUTHENTICATION)
            window.location.href = response?.link;
          else paymentError();
        } catch (err: any) {
          setIsPaying(false);
        }
      }
    },
    500,
    { leading: true, trailing: false }
  );

  /* Styling */

  /* Render */
  return (
    <CheckoutPaymentFrame
      config={
        config?.payment_gateways?.find(
          (g) => g.payment_gateway === PaymentGatewayName.CHECKOUT
        )?.config as CheckoutConfig
      }
      errorMsg={error}
      handleSubmit={handleSubmit}
      isPaying={isPaying}
    />
  );
}
export default CheckoutBidBuyFrame;
